export const DASHBOARD_MASTER_DATA_FILTER = "DASHBOARD_MASTER_DATA_FILTER";
export const DASHBOARD_MASTER_DATA_CLEAR_DATA_FILTER = "DASHBOARD_MASTER_DATA_CLEAR_DATA_FILTER";
